module.exports = __webpack_public_path__ + "img/mark_title_sel.e1c78654.png";